<div class="no-print container mt-3 mb-1">
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <h3>
        <span class="font-bold"
          >{{ activeSeasonId }}
          {{ 'selectVaccines.season' | cxTranslate }}</span
        >
      </h3>
    </div>
    <div class="d-flex gap-3">
      <span class="c-link" (click)="backToDashBoard()">
        <i class="fa fa-icon fa-chevron-left"></i>
        {{ 'selectVaccines.back_to_db' | cxTranslate }}
      </span>
      <span class="c-link" (click)="downloadExcel()">
        <i class="fa fa-icon fa-file-excel"></i>
        {{ 'selectVaccines.xls' | cxTranslate }}</span
      >
      <span class="c-link" (click)="onFluPrint()">
        <i class="fa fa-icon fa-print"></i>
        {{ 'selectVaccines.print' | cxTranslate }}</span
      >
    </div>
  </div>
</div>

<section class="mb-4 mt-4 row">
  <!-- Left -->
  <div
    class="col-8"
    *ngFor="let order of dataForFluConfirmation; let i = index">
    <div
      class="u-border-top-grey mb-5"
      *ngIf="dataForFluConfirmation.length > 1 && i > 0"></div>
    <div class="u-border-right-grey pr-md-4 pr-lg-5 mb-5">
      <div
        class="d-flex col-12 pb-4 u-border-bottom-grey justify-content-between">
        <div *ngIf="isPharmacyUser$ | async">
          <i class="fa fa-map-marker-alt font-n"></i>
          <span class="px-3 text-fixed-medium"
            >{{ order.shippingAddress?.companyName }}
            {{ '(' + order.shippingAddress?.unitID + ')' }}</span
          >
        </div>
        <div class="d-flex">
          <span class="font-bold mr-1">{{
            'orderConfirmation.po' | cxTranslate
          }}</span>
          <span *ngIf="order?.purchaseOrderNumber; else NA">{{
            order?.purchaseOrderNumber
          }}</span>
          <ng-template #NA>
            WWW:{{ order?.created | slice: 0 : 10 | date: DATE_FORMAT }}
          </ng-template>
        </div>
      </div>
      <div class="mt-4">
        <div class="col-md-12">
          <!-- Sold to -->
          <div class="row pb-4" *ngIf="isPharmacyUser$ | async">
            <div class="col-md-8">
              <h3 class="font-bold">
                {{ 'orderConfirmation.soldTo' | cxTranslate }}
              </h3>
              <p class="text-fixed-medium">
                #{{ order.shippingAddress?.unitID }}
              </p>
            </div>
            <div class="col-md-4 text-fixed-medium">
              <div class="row">
                <div class="col-md-6">
                  {{ 'orderConfirmation.subTotal' | cxTranslate }}
                </div>
                <div class="col-md-6 text-right">
                  {{ order?.subTotal?.formattedValue }}
                </div>
              </div>
              <div class="row py-1">
                <div class="col-md-6">
                  {{ 'orderConfirmation.salesTax' | cxTranslate }}
                </div>
                <div class="col-md-6 text-right">
                  {{ order.totalTax?.formattedValue }}
                </div>
              </div>
              <div class="row u-border-top-grey font-bold py-1">
                <div class="col-md-6">
                  {{ 'orderConfirmation.totalWithSaving' | cxTranslate }}
                </div>
                <div class="col-md-6 text-right">
                  {{ order.totalPriceWithTax?.formattedValue }}
                </div>
              </div>
              <div class="row mt-2" *ngIf="order?.freightProduct">
                <section class="col-md-12 text-fixed-legal">
                  <p>
                    {{ 'addToCartItems.shippingChargesNote' | cxTranslate }}
                  </p>
                </section>
              </div>
            </div>
          </div>
          <!-- Ship to -->
          <div class="row" *ngIf="isPharmacyUser$ | async">
            <div class="col-md-12">
              <h3 class="font-bold">
                {{ 'orderConfirmation.shipTo' | cxTranslate }}
              </h3>
            </div>
            <div class="col-md-12 text-fixed-medium pb-4">
              <p class="mb-0">
                {{
                  order.shippingAddress?.companyName
                    ? order.shippingAddress?.companyName
                    : ''
                }}
              </p>
              <p class="mb-0 d-flex flex-column" addressFormat>
                <span>{{ order.shippingAddress?.line1 }}</span>
                <span>{{ order.shippingAddress?.line2 }}</span>
                <span>{{ order.shippingAddress?.town }}</span>
                <span>{{ order.shippingAddress?.postalCode }}</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h3 class="font-bold">
                {{ 'orderConfirmation.orderDate' | cxTranslate }}
              </h3>
            </div>
            <div class="col-md-12 text-fixed-medium pb-4">
              <p class="mb-0">
                <span class="data">{{
                  order?.created || order?.creationTime
                    | slice: 0 : 10
                    | date: DATE_FORMAT
                }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <section
        class="row u-border-top-grey py-4 mt-4 mt-md-0"
        *ngFor="let productEntry of order?.entries">
        <!-- Image -->
        <section class="col-md-2 mb-4">
          <a (click)="productDetails(productEntry)">
            <cx-media
              *ngIf="productEntry?.product?.images"
              [container]="productEntry?.product?.images"
              format="thumbnail">
            </cx-media>
            <img
              *ngIf="!productEntry?.product?.images"
              [src]="fallbackImage"
              alt="defImg" />
          </a>
        </section>
        <!-- details -->
        <section class="col-md-10">
          <section class="row c-prod-details">
            <!-- Title -->
            <div class="col-md-12">
              <a (click)="productDetails(productEntry)">
                <h2
                  class="font-bold c-heading c-heading-h4 mb-4"
                  [innerHTML]="productEntry?.product?.name"></h2>
              </a>
            </div>
            <!-- Units -->
            <div
              class="col-md-12 d-md-flex justify-content-between text-fixed-medium">
              <div>
                <span class="font-bold d-block">{{
                  'plp.units' | cxTranslate
                }}</span>
                <span class="mr-1">{{ productEntry?.quantity }}</span>
                @if (productEntry?.product?.quantityPerUnit) {
                  <span>{{
                    'flu.checkout.doses-in-pack'
                      | cxTranslate
                        : {
                            doses:
                              productEntry?.product?.quantityPerUnit *
                              productEntry?.quantity,
                          }
                  }}</span>
                }
              </div>

              <div *ngIf="isPharmacyUser$ | async">
                <span class="font-bold">{{
                  'plp.yourPrice' | cxTranslate
                }}</span>
                <span class="d-none d-md-block">{{
                  productEntry?.basePrice?.formattedValue
                }}</span>
              </div>

              <div *ngIf="isPharmacyUser$ | async">
                <span class="font-bold">{{
                  'addToCartItems.subtotal' | cxTranslate
                }}</span>
                <span class="d-inline-block d-sm-none"
                  >:&nbsp;{{ productEntry?.totalPrice?.formattedValue }}
                </span>
                <span class="d-none d-md-block">{{
                  productEntry?.totalPrice?.formattedValue
                }}</span>
              </div>
            </div>
            <section class="col-md-12 text-fixed-medium py-4">
              <div
                class="m-0"
                [innerHTML]="productEntry?.product?.description"></div>
            </section>
            <section class="col-md-12 text-fixed-medium">
              <span class="font-bold">{{
                'plp.productNumber' | cxTranslate
              }}</span>
              <span class="prdct-No">{{ productEntry?.product?.sapEan }}</span>
            </section>
            <section
              *ngIf="productEntry?.product?.sor"
              class="col-md-12 text-fixed-medium">
              <span class="font-bold">{{
                'flu.product.sor' | cxTranslate
              }}</span>
              <span>{{ productEntry?.product?.sor }}%</span>
            </section>
          </section>
        </section>
      </section>
    </div>
  </div>
  <!-- Sidebar -->
  <div class="col-4 pl-md-4 pl-lg-5">
    <div class="row d-md-none">
      <div class="col-md-12 u-border-top-grey pb-4"></div>
    </div>
    <div class="row mb-5 u-border-bottom-grey" *ngIf="isPharmacyUser$ | async">
      <!-- Total -->
      <div
        class="d-flex gap-1 col-md-12 py-4 d-flex align-items-center justify-content-center justify-content-md-between flex-column flex-md-row">
        <h3 class="font-bold mb-0">
          {{ 'orderConfirmation.estimatedTotal' | cxTranslate }}
        </h3>
        <h3 class="font-bold mb-0">
          {{ estTotal?.formattedValue }}
        </h3>
      </div>
    </div>
    <div class="row col-12" *ngIf="!(isDirectUser$ | async)">
      <app-wholesaler-pharmacy [editable]="false"></app-wholesaler-pharmacy>
    </div>
    <div class="pt-4 row">
      <app-flu-confirmation-right-content></app-flu-confirmation-right-content>
    </div>
  </div>
</section>
